// @ts-check
if (!customElements.get('cart-matching-product')) {
  class FvbCartMatchingProduct extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const mobileButton = this.querySelector('.cart-matching-product__mobile');
      if (!mobileButton) return;
      mobileButton.addEventListener('click', () => {
        this.classList.toggle('is-open');
      });
    }
  }
  customElements.define('cart-matching-product', FvbCartMatchingProduct);
}
